import { deleteDoc, doc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { INumber } from "@leedpulse-monorepo/interfaces";

async function deleteNumber(
  number: INumber,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new DeleteNumberFailure("Unauthorized", "unauthorized");
  }
  try {
    const numberId = number.sender;
    await deleteDoc(doc(firestore, FirestoreCollections.numbers, numberId));
    return;
  } catch (e) {
    console.log("error: ", e);
    throw new DeleteNumberFailure();
  }
}

export class DeleteNumberFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default deleteNumber;
